import Slideshow from './components/slideshow';
import OverlayGallery from './components/overlay-gallery';
import LazyImage from './components/lazy-image';

export default class Default {
  constructor(main) {
    new Slideshow(main, this);
    new OverlayGallery(main, this);
    new LazyImage(main, this);

    //Use lazy load
    Vue.use(VueClazyLoad);
  }
}